import { Component } from '@angular/core';

@Component({
  selector: 'docheader-secondary-nav-skeleton',
  templateUrl: './docheader-secondary-nav-skeleton.component.html',
  standalone: false,
})
export class DocheaderSecondaryNavSkeletonComponent {
  skeletonTabs = [1, 2];
}
